// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mlBF","right":"styles_right__Cel8y"};